import React from "react";
import * as notify from "../../../shared/notify";
import classnames from "classnames";

import { readOnlyValue } from "../lib/attribute-data";
import { checkDataTypeAllowed, validateValueByType } from "../lib/helpers";
import { isNil } from "lodash";

const ReadOnlyField = ({ matched, ...props }) => {
    const { componentType, readOnly } = props.attribute;
    const value = isNil(props.value) ? props.defaultValue : props.value;
    const textValue = readOnlyValue(value, componentType, props.attribute, props.upc, props.wipKey, props.taskType, props.roleType, props.roleLabel);
    const isBooleanType = componentType === "Boolean" && typeof value === "boolean";
    const isStringBooleanType = componentType === "Boolean" && (value === "true" || value === "false");
    const isNumericType = typeof value === "number";

    const pasteValue = (e) => {
        if ((readOnly && !props.readOnlyOverride) || !e.altKey || props.isCompleted) {
            return;
        }

        if (!checkDataTypeAllowed(componentType)) {
            notify.error(`${componentType} is not allowed to be copied`);

            return;
        }

        if (!validateValueByType(value, componentType)) {
            notify.error("One Click Copy Disabled: DataType is inconsistent");

            return;
        }

        if (props.updateAttribute) {
            props.updateAttribute(value);
        }
    };
    const cssClass = classnames("", {
        "match-box": matched,
        "gray-box": props.grayed,
        "txt-notAllowed": !props.isCompleted && readOnly,
        "one-click-copy": !props.isCompleted && props.isCompleted,
    });

    if (value || isNumericType || isBooleanType || isStringBooleanType) {
        return (
            <div
                className={cssClass}
                onMouseUp={pasteValue}
            >
                {textValue}
            </div>
        );
    }

    return <div className={`${props.grayed ? "gray-box" : ""}`} />;
};

export default ReadOnlyField;
